"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Check = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 16 12", fill: "currentColor", width: size || "16", height: size || "12" }, props),
        React.createElement("g", { id: "Symbols", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "Buttons-/-Box-Button-/-Success-/-Icon-Copy", transform: "translate(-58 -14)", fill: "currentColor" },
                React.createElement("g", { id: "Icons-/-Check-/-Bold", transform: "translate(54 8)" },
                    React.createElement("path", { d: "M18.3136362,7.71301485 L18.6360088,7.36934666 L18.6353838,7.34268869 L18.2990357,7.69884361 L18.3136362,7.71301485 Z M5.31339777,12.4034164 L5.31535398,12.4279974 L5.68535858,12.7239424 L5.69635283,12.7097196 L5.31339777,12.4034164 Z M18.2802035,6.28698515 L19.7009643,7.66597596 L10.3083211,17.6790879 L4.30364717,12.8763019 L5.51599094,11.3079495 L10.1177586,14.9886332 L18.2802035,6.28698515 Z", id: "Path-2" }))))));
};
Check.displayName = 'Check';
exports.default = Check;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Check.js.map